import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUserLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from 'react-select'
const UserProfile = () => {
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [showAlertMessage, setshowAlertMessage] = useState({
    status:false,
    message:''
  });
  const [selectedOptions, setSelectedOptions] = useState({});
  const handleChange = (selected) => {
    setSelectedOptions(selected);
  };
  const [jobsData , setJobData] = useState([])
  const fetchJobs = async ()=>{
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       let response = await fetch("https://api.rankers.frontforcecrm.com/api/affiliates/fetch-affiliates", { 
         method: "GET",
         headers: headersList
       });
       let data = await response.json();
       const formattedData = data.map((e) => ({
        value: e.id,
        label: e.business_name
      }));
      setJobData(formattedData)
}
React.useEffect(()=>{
  fetchJobs()
  getCurrentUser();
},[1])
const [currentUser,setCurrentUser] = useState({})
const getCurrentUser = ()=>{
  const user = JSON.parse(localStorage.getItem('user'));
  if(user == null){
    window.location.href = '/sign-in'
  }else{
    setCurrentUser(user)
  }
}

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
    
  };
  
  // const onFormSubmit = async (event) =>{
  //   event.preventDefault();
  //   let headersList = {
  //       "Accept": "*/*",
  //       "Content-Type": "application/json"
  //      }
       
  //      let bodyContent = JSON.stringify({
  //        "name": event.target.elements.fullname.value,
  //        "email": event.target.elements.email.value,
  //        "password":event.target.elements.password.value
  //      });
       
  //      let response = await fetch("https://api.rankers.frontforcecrm.com/api/user/create", { 
  //        method: "POST",
  //        body: bodyContent,
  //        headers: headersList
  //      });
       
  //   //    let data = await response.text();
     
  //    let data = await response.json();
  //    if(response.status == 201){
  //     setshowAlertMessage({
  //       message: 'success',
  //       status:true
  //     });
  //     event.target.elements.fullname.value='';
  //     event.target.elements.email.value='';
  //     event.target.elements.password.value='';
  //    }else{


  //     setshowAlertMessage({
  //       message: 'error',
  //       status:true
  //     });
  //    }
     
  // }
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="My Profile" />

        {/* AddUserLayer */}
        <div className="card h-100 p-0 radius-12">
          <div className="card-body p-24">
            <div className="row justify-content-center">
              <div className="col-xxl-6 col-xl-8 col-lg-10">
                <div className="card border">
                  <div className="card-body">
                   
                    {/* Upload Image Start */}

                    {/* Upload Image End */}
                    <form onSubmit={(event)=>{
                      event.preventDefault();
                      alert('Under dev')
                    }}>
                    {
                      showAlertMessage.status === true?
                    <div
                        className={
                          showAlertMessage.message == 'error' ?
                          "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10":
                          "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                        }
                        role="alert"
                    >
                        {showAlertMessage.message == 'error' ? "Error while adding new user" : "User Is added successfully"}
                        <button type="button" onClick={()=>setshowAlertMessage(!showAlertMessage)} className="remove-button text-secondary-600 text-xxl line-height-1">
                            {" "}
                            <Icon icon="iconamoon:sign-times-light" className="icon" />
                        </button>
                    </div>:null
                    }

                      <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Full Name <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          value={currentUser.name}
                          onChange={(e)=>setCurrentUser((prev)=>({...prev, name : e.target.value}))}
                          name="fullname"
                          className="form-control radius-8"
                          id="name"
                          
                          placeholder="Enter Full Name"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          name="email"
                          className="form-control radius-8"
                          id="email"
                          disabled
                          value={currentUser.email}
                          onChange={(e)=>setCurrentUser((prev)=>({...prev, name : e.target.email}))}
                          placeholder="Enter email address"
                        />
                      </div>
                      <div className="mb-20">
                      <p >Change Password</p>
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="password"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Old Password
                        </label>
                        <input
                          type="password"
                          name="password"
                          className="form-control radius-8"
                        //   value={currentUser.password}
                        //   onChange={(e)=>setCurrentUser((prev)=>({...prev, password : e.target.value}))}
                          
                          
                          placeholder="******"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="password"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          New Password
                        </label>
                        <input
                          type="password"
                          name="password"
                          className="form-control radius-8"
                        //   value={currentUser.password}
                        //   onChange={(e)=>setCurrentUser((prev)=>({...prev, password : e.target.value}))}
                          
                          
                          placeholder="******"
                        />
                      </div>
                    
                    
                   
                      <div className="d-flex align-items-center justify-content-center gap-3">
                        <button
                          type="button"
                          className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default UserProfile;
